import { render, staticRenderFns } from "./CommonLinks.vue?vue&type=template&id=68c60ab0&"
import script from "./CommonLinks.vue?vue&type=script&lang=js&"
export * from "./CommonLinks.vue?vue&type=script&lang=js&"
import style0 from "./CommonLinks.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports